import React, { Component } from 'react'

import PropTypes from 'prop-types';

import fileUpload from '../../../assets/images/newui/file-upload.png'
import fileUploadRemove from '../../../assets/images/newui/remove-img.svg'

import './DGUploadFile.less'
import { Grid } from 'semantic-ui-react';

//import DropZone from 'react-drop-zone'
//import 'react-drop-zone/dist/styles.css'
import Dropzone from 'react-dropzone';

const initialState = { files: [] };

/**
 * @augments Component({Props, State})
 */
class DGUploadFile extends Component {

    static propTypes = {
        /*onDrop: PropTypes.func.isRequired,
        onFileDialogCancel: PropTypes.func.isRequired,*/
        fileType: PropTypes.oneOf(['images', 'documents']).isRequired,
        multiple: PropTypes.bool,
        minFileCount: PropTypes.number.isRequired,
        /**Max number of files to be uploaded */
        maxFileCount: PropTypes.number.isRequired
    }

    constructor(props) {
        super(props);
        this.state = initialState;

        this.dropzoneRef = React.createRef();

    }

    componentDidMount() {
        /*if (!this.props.onDrop) {
            throw 'DGUploadFile requires onDrop handler';
        }*/
        /*if (!this.props.onFileDialogCancel) {
            throw 'DGUploadFile requires onFileDialogCancel handler';
        }*/

        if (!this.props.fileType) {
            throw 'DGUploadFile requires fileType attribute';
        }
    }

    componentDidUpdate = (prevProps) => {
        
        if(prevProps.value != this.props.value /*&& (this.props.value == null || this.props.value == [])*/){
            if(this.props.value == null || this.props.value.length == 0){
                this.setState({files: []})
            }
            //this.setState({files: []})
        }
    }

    onDrop = (files) => {
        const numberOfSlotsRemaining = this.props.maxFileCount - this.state.files.length;
        if (files.length > numberOfSlotsRemaining) {
            files = _.dropRight(files, files.length - numberOfSlotsRemaining);
        }

        let stateFiles = [...this.state.files];
        for (let i = 0; i < files.length; i++) {
            const existingFile = _.find(stateFiles, function (stateFile) {
                return files[i].name === stateFile.name && files[i].lastModified == stateFile.lastModified;
            });

            if (!existingFile) {
                stateFiles.push(files[i]);
                this.setState({ files: stateFiles }, () => {
                    this.props.onDrop(this.state.files);
                });
            }
        }


        /*files.map((file) => {

        });*/


    }

    onRemoveUploadImg = (fileName, lastModified) => {
        let { files } = this.state;

        _.remove(files, function (file) {
            return file.name === fileName && file.lastModified == lastModified;
        });

        this.setState({ files: files }, () => {
            this.props.onRemove(this.state.files);
        });
    }
    render() {
        
        return (
            <div className="drop-zone-container">
                {this.state.files.length > 0 &&
                    <div className="files-thumbnail-container">
                        {this.state.files.map((file) => {
                            return <div className="file-thumbnail">
                                <img src={URL.createObjectURL(file)} />
                                <img src={fileUploadRemove} className="img-remove" onClick={() => this.onRemoveUploadImg(file.name, file.lastModified)} />
                            </div>
                        })}


                    </div>
                }


                {/*<DropZone onDrop={this.onDrop} multiple >
                    {({ over, overDocument }) =>

                        <div>
                            {
                                <section>

                                    <div className={this.state.files.length > 0 ? 'file-upload-thumbnail' : (overDocument) ? 'drop-zone-active' : 'drop-zone'}>
                                        {this.state.files.length == 0 &&
                                            <Grid>
                                                <Grid.Column computer={5} mobile={16}>
                                                    <img className="file-upload-image" src={fileUpload}></img>
                                                </Grid.Column>
                                                <Grid.Column computer={9} mobile={16}>

                                                    <React.Fragment>
                                                        <p className="main-msg">
                                                            Click or drop files here to add images of the area being serviced
                                                        </p>
                                                    </React.Fragment>

                                                </Grid.Column>

                                            </Grid>

                                        }
                                        {this.state.files.length > 0 &&

                                            <img src={fileUpload} />

                                        }

                                    </div>
                                </section>

                            }
                        </div>
                    }
                </DropZone> */}

                {(this.state.files.length == 0 || (this.state.files.length > 0 && this.props.multiple == true)) &&
                <Dropzone onDrop={this.onDrop.bind(this)} onFileDialogCancel={this.props.onFileDialogCancel} disabled
                    accept={this.props.fileType == 'images' ? "image/*" : ""} {...{
                        multiple: this.props.multiple ? true : false,
                        disabled: this.props.disabled ? true : false,
                    }}>
                    {({ getRootProps, getInputProps, acceptedFiles, isDragReject, isDragActive }) => (
                        <section>
                            <div {...getRootProps({ className: this.state.files.length > 0 ? 'file-upload-thumbnail' : (isDragActive && isDragReject) ? 'drop-zone reject' : (isDragActive && !isDragReject) ? 'drop-zone-active' : 'drop-zone' })}>
                                <input {...getInputProps()} />


                                {this.state.files.length == 0 &&
                                    (this.props.template ? this.props.template : <Grid>
                                        <Grid.Column computer={5} mobile={16}>
                                            <img className="file-upload-image" src={fileUpload}></img>
                                        </Grid.Column>
                                        <Grid.Column computer={9} mobile={16}>
                                            {!isDragReject &&
                                                <React.Fragment>
                                                    <p className="main-msg">
                                                        {this.props.mainmessage ? this.props.mainmessage : 'Click or drop files here to add images of the area being serviced'}
                                                </p>
                                                    <p className="sub-msg">
                                                    {this.props.submessage ? this.props.submessage : 'Adding images provides more competitive quotes.'}
                                                    </p>

                                                </React.Fragment>
                                            }
                                            {isDragReject &&
                                                <React.Fragment>
                                                    <p className="main-msg error">
                                                    {this.props.mainmessage ? this.props.mainmessage : 'Click or drop files here to add images of the area being serviced'}
                                        </p>


                                                </React.Fragment>
                                            }
                                        </Grid.Column>

                                    </Grid>)
                                }

                                {this.state.files.length > 0 &&

                                    <img src={fileUpload} />

                                }

                            </div>
                            <div className="clearfix"></div>
                            <br />


                        </section>

                    )}
                </Dropzone> 
                }
            </div>

        )
    }
}

/*DGUploadFile.propTypes = {
                    onDrop: PropTypes.func.isRequired,
    onFileDialogCancel: PropTypes.func.isRequired,
    fileType: PropTypes.oneOf(['images', 'documents']).isRequired,
    multiple: PropTypes.bool
}*/

export default DGUploadFile;
